import React from 'react';
import { motion } from 'framer-motion';

const Schedule = () => {
  const scheduleItems = [
    { time: '10:20 น.', title: 'ลงทะเบียน', description: 'ณ ท่าเรือเกาะลอย ศรีราชา' },
    { time: '10:50 น.', title: 'เดินทางโดยเรือสปีดโบ๊ท', description: 'เดินทางไปยังเกาะสีชัง' },
    { time: '11:30 น.', title: 'รับประทานอาหารกลางวัน', description: 'อาหารที่คัดสรรเป็นพิเศษ' },
    { time: '12:30 น.', title: 'พิธีขจัดเสนียด', description: 'ตามหลักโหราศาสตร์จีน' },
    { time: '13:00 น.', title: 'พิธีเชื่อมพลังมังกร ขอพรเจ้าพ่อเขาใหญ่ เกาะสีชัง', description: 'โดยนักพรตผู้เชี่ยวชาญ' },
    { time: '15:00 น.', title: 'เดินทางกลับจากเกาะ', description: 'เดินทางกลับสู่ท่าเรือเกาะลอย' },
    { time: '15:30 น.', title: 'ขึ้นฝั่งที่เกาะลอย จบทริป', description: 'เดินทางกลับโดยสวัสดิภาพ' }
  ];

  return (
    <section id="schedule" className="py-10 md:py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">กำหนดการ</h2>
          <p className="text-xl text-gray-600 mb-2">
            วันพฤหัสที่ 19 พฤศจิกายน 2569
          </p>
          <p className="text-lg text-red-600 font-semibold">
            หมายเหตุ: ไม่มีการค้างคืน กลับภายในวันเดียว
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg px-6 py-6 sm:px-8">
          <div className="relative ml-2 border-l-2 border-red-200">
            {scheduleItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.06 }}
                viewport={{ once: true }}
                className="relative pl-6 pb-5 last:pb-0"
              >
                <span className="absolute -left-[7px] top-1 w-3 h-3 bg-red-600 rounded-full border-2 border-white shadow" />
                <div className="flex flex-wrap items-baseline gap-x-3">
                  <span className="text-sm font-bold text-red-600 whitespace-nowrap">{item.time}</span>
                  <h3 className="text-base font-semibold text-gray-900">{item.title}</h3>
                </div>
                <p className="text-sm text-gray-500">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;